<div (blur)="onBlur()">
  @if (template()) {
    <ng-container *ngTemplateOutlet="template()!; context: templateContext()" />
  }
  @if (!template()) {
    {{ text() }}
  }
</div>
